package org.braunequip.web.components.bulma

import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.vh
import org.jetbrains.compose.web.css.vw
import org.jetbrains.compose.web.dom.Button
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H1
import org.jetbrains.compose.web.dom.Text

val lightboxStyle = CssStyle {
    base {
        Modifier
//            .zIndex(9)
            .fillMaxSize()
    }
}

@Composable
fun BulmaLightbox() {
    Box(Modifier.fillMaxSize(), contentAlignment = Alignment.Center) {
        H1(Modifier.color(Colors.White).toAttrs()) { Text("THIS IS MY TEST FOR THE OVERLAY") }
    }
}

@Composable
fun BulmaModal(toggleOn: MutableState<Boolean>, id: String, content: @Composable () -> Unit) {
    Div(Modifier
        .id(id)
        .classNames(
            "modal",
        )
        .toAttrs()) {


        Div(Modifier.classNames("modal-background").toAttrs{
            onClick {
                BulmaModalClose(id)
            }}) {}
        Div(Modifier.classNames("modal-content").toAttrs()) {
            content()
        }
        Button(Modifier
            .classNames("modal-close", "is-large")
            .ariaLabel("close")
            .onClick {
                BulmaModalClose(id)
            }
            .toAttrs()) {}
    }
}